import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { countUnique, countUniqueTime } from '@utils/summaries';
import { MaterialMap } from '@consts/materials';
import { basicSort, dateSort } from '@utils/sort';
import { useRange } from '@hooks/useRange';
import { styleDateRange, styleTime } from '@utils/styles';
import { REPORT } from '@consts/reports';

import type { Materials } from '@consts/materials';

interface LocationsNoCutsByMaterialProps {
    dateRange: { startDate: string; endDate: string };
    material: Materials;
}

export const LocationsNoCutsByMaterial = ({ dateRange, material }: LocationsNoCutsByMaterialProps) => {
    const materialId = MaterialMap[material];

    const [range, setRange] = useRange('LocationsNoCutsByMaterial');

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.ISSUES_LOCATIONS_HAVE_NOT_CUT,
        params: { range, materialId, ...dateRange },
    });

    return (
        <BaseReport
            title={`Locations who have not cut ${material}`}
            description={`This is a list of locations which did not make a cut for ${material} film in the entire date range above. This may be an indication that the location does not carry ${material}, or has run out of ${material} sheets.`}
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            setRange={setRange}
            range={range}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Location Name', 'Reseller Name', `Last Successful ${material} Cut`],
                data: data.map((item) => [item.locationName, item.resellerName, item.lastSuccessfulCut || 'never']),
                style: [null, null, styleTime],
                summaries: [countUnique, countUnique, countUniqueTime],
                sort: [basicSort, basicSort, dateSort(range)],
            }}
        />
    );
};
